import React from 'react';

const ItemCategory = ({ item }) => {
    return <div className="col-sm-6 col-lg-4 mb-3" key={item.img}>
        <a className="card card-stretched-vertical card-transition shadow-none bg-img-start gradient-y-overlay-lg-dark" href={item.link} style={{ backgroundImage: `url(${item.img})`, minHeight: "15rem" }}>
            <div className="card-body">
                <div className="mb-1">
                    <span className="badge bg-light text-dark">{item.offer}</span>
                </div>

                <div className="card-footer">
                    <h3 className="text-white mb-0">{item.name}</h3>
                    <span className="d-block text-white">{item.price}</span>
                </div>
            </div>
        </a>
    </div>;
}

export default ItemCategory;
